import React, { useState } from 'react';

function DeleteAccount() {
  const [lang, setLang] = useState('hr');

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '40px 20px 80px', fontFamily: 'sans-serif', color: '#222' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
        <a href="/" style={{ color: '#2d6a4f', textDecoration: 'none', fontWeight: 600 }}>← Ubrano</a>
        <div>
          <button onClick={() => setLang('hr')} style={{ marginRight: 8, fontWeight: lang === 'hr' ? 700 : 400, background: 'none', border: 'none', cursor: 'pointer', color: '#2d6a4f' }}>HR</button>
          <button onClick={() => setLang('en')} style={{ fontWeight: lang === 'en' ? 700 : 400, background: 'none', border: 'none', cursor: 'pointer', color: '#2d6a4f' }}>EN</button>
        </div>
      </div>

      {lang === 'hr' ? (
        <>
          <h1 style={{ color: '#2d6a4f' }}>Brisanje računa</h1>
          <p>
            Možete zatražiti brisanje vašeg Ubrano računa i svih povezanih podataka.
            Nakon brisanja, sljedeći podaci bit će trajno uklonjeni:
          </p>
          <ul>
            <li>Vaša e-mail adresa i podaci o računu</li>
            <li>Podaci o vašem OPG-u (ako ste registrirani kao prodavač)</li>
            <li>Vaše zone upozorenja</li>
            <li>Vaši interesi i ocjene</li>
            <li>Vaše dostave, polja i štandovi</li>
          </ul>
          <p>
            Napomena: ocjene koje su drugi korisnici dali vašem OPG-u mogu biti zadržane
            u anonimiziranom obliku radi integriteta sustava ocjenjivanja.
          </p>

          <h2 style={{ color: '#2d6a4f' }}>Kako zatražiti brisanje</h2>
          <p>Pošaljite e-mail na:</p>
          <p style={{ fontSize: 20, fontWeight: 700, color: '#2d6a4f' }}>
            <a href="mailto:privacy@ubrano.com.hr" style={{ color: '#2d6a4f' }}>privacy@ubrano.com.hr</a>
          </p>
          <p>U poruci navedite:</p>
          <ul>
            <li>Naslov: <strong>Zahtjev za brisanje računa</strong></li>
            <li>E-mail adresa vašeg Ubrano računa</li>
          </ul>
          <p>Odgovorit ćemo i obrisati vaš račun u roku od <strong>30 dana</strong>.</p>
          <p style={{ color: '#888', fontSize: 14, marginTop: 40 }}>
            Ubrano · privacy@ubrano.com.hr · <a href="/privacy" style={{ color: '#2d6a4f' }}>Pravila privatnosti</a>
          </p>
        </>
      ) : (
        <>
          <h1 style={{ color: '#2d6a4f' }}>Delete Your Account</h1>
          <p>
            You can request deletion of your Ubrano account and all associated data.
            After deletion, the following data will be permanently removed:
          </p>
          <ul>
            <li>Your email address and account details</li>
            <li>Your OPG/farm details (if registered as a seller)</li>
            <li>Your alert zones</li>
            <li>Your interests and ratings given</li>
            <li>Your delivery events, fields, and stands</li>
          </ul>
          <p>
            Note: ratings that other users have given your OPG may be retained in
            anonymised form to preserve the integrity of the rating system.
          </p>

          <h2 style={{ color: '#2d6a4f' }}>How to Request Deletion</h2>
          <p>Send an email to:</p>
          <p style={{ fontSize: 20, fontWeight: 700 }}>
            <a href="mailto:privacy@ubrano.com.hr" style={{ color: '#2d6a4f' }}>privacy@ubrano.com.hr</a>
          </p>
          <p>Please include:</p>
          <ul>
            <li>Subject: <strong>Account deletion request</strong></li>
            <li>The email address of your Ubrano account</li>
          </ul>
          <p>We will respond and delete your account within <strong>30 days</strong>.</p>
          <p style={{ color: '#888', fontSize: 14, marginTop: 40 }}>
            Ubrano · privacy@ubrano.com.hr · <a href="/privacy" style={{ color: '#2d6a4f' }}>Privacy Policy</a>
          </p>
        </>
      )}
    </div>
  );
}

export default DeleteAccount;
